import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class StateCultureInsertService {

  private apiUrl = globalConst.baseAPI;
  constructor(private http: Http) { }

  insertStateCulture(token, stateCulture: any) {
  	console.log(stateCulture);

  	return this.http
  		.post(this.apiUrl + "stateculture/v1/insertculture", stateCulture, JSON.parse(localStorage.getItem('yara.connectionHeader')))
  		.map((res: Response) => res.json())
  		.catch(e => {
  			if (e.status === 401) {
  				return Observable.throw('Unauthorized');
  			}
  		});
  }

}



// WEBPACK FOOTER //
// ./src/app/stateculture/service/stateculture-insert/stateculture-insert.service.ts